import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetMetadataRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}KPIsOverview/GetMetadata`,
	params: {}
});

export const GetSitesRequest = (technology, granularity) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}KPIsOverview/GetSites`,
	params: { technology, granularity }
});

/*
 * Lista de celulas dos sites escolhidos. POST porque siteIds pode ser uma
 * lista grande (nao cabe bem numa query string). O backend faz um
 * SELECT DISTINCT da coluna de celula restrito a WHERE <site> IN (siteIds),
 * o que e barato por estar limitado a poucos sites.
 */
export const GetCellsRequest = (technology, granularity, siteIds) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}KPIsOverview/GetCells`,
	data: { technology, granularity, siteIds }
});

export const GetKpiSeriesRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}KPIsOverview/GetKpiSeries`,
	data: { values, userId }
});

export const ExportKpiSeriesRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}KPIsOverview/ExportKpiSeries`,
	data: { values, userId }
});
